// Define type-safe string literal unions for scheduler views and color coding
export type SchedulerViewType = 'day' | 'week' | 'work-week' | 'month' | 'timeline';
export type ColorCodingType = 'employee' | 'status';

export interface SchedulerConfig {
  // Color coding section
  colorCodingType: ColorCodingType;
  
  // Misc config section
  showFullDay: boolean;
  showAllDayColumn: boolean; // Whether to show the all day column in the scheduler
  defaultAppointmentLength: number; // in minutes
  slotDuration: number; // division size in minutes (5, 15, 30, or 60); each slot has 2 divisions so major slot = 2x
  
  // UI hints and tips
  showHint0: boolean; // Controls visibility of the scheduler info hint
  
  // Business hours configuration
  businessHours: {
    start: string; // Format: "HH:MM" (24-hour format)
    end: string;   // Format: "HH:MM" (24-hour format)
  };
  
  // Choice of view section
  defaultView: SchedulerViewType; // Type-safe string literal union
  
  // Data display section
  displayOptions: {
    showJobNumber: boolean;
    showCustomerName: boolean;
    showLocation: boolean;
    showDescription: boolean;
    showEmployees: boolean;
    showStatus: boolean;
  };
  
  // Export section (disabled for now)
  // exportOptions: {}
}

export const defaultSchedulerConfig: SchedulerConfig = {
  colorCodingType: 'status',
  showFullDay: false,
  showAllDayColumn: false, // Default to showing the all day column
  defaultAppointmentLength: 60,
  slotDuration: 30, // Default to 30 minutes
  showHint0: true,
  businessHours: {
    start: "08:00", // Default business hours start at 8 AM
    end: "17:00"    // Default business hours end at 5 PM
  },
  defaultView: 'timeline',
  displayOptions: {
    showJobNumber: true,
    showCustomerName: true,
    showLocation: true,
    showDescription: true,
    showEmployees: true,
    showStatus: true
  }
};